import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import styles from './commentsStyles';

import CommentContainer from 'buyside/components/container/CommentContainer';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';

import { accessIdeasUrl } from 'buyside/util/urlHelper';

class Comments extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fetchingComments: false };

    this.handleFetchComments = this.handleFetchComments.bind(this);
  }

  handleFetchComments() {
    if (this.state.fetchingComments) return;

    if (window.hj) {
      window.hj('tagRecording', ['activity_feed_load_more_comments']);
    }

    const resetFetchingCommentState = () => {
      this.setState({ fetchingComments: false });
    };
    this.setState({ fetchingComments: true });
    this.props.loadMoreEntries().then(resetFetchingCommentState, resetFetchingCommentState);
  }

  renderLoadMoreSection() {
    const comments = this.props.comments;
    if (!comments || !comments.pageInfo || comments.edges.length === 0) return null;
    let showMore = null;
    if (comments.pageInfo.hasNextPage && comments.pageInfo.endCursor) {
      showMore = (
        <div className={styles.moreCommentsSection}>
          <Button
            id="load-previous-comments"
            onClick={this.handleFetchComments}
            type={BUTTON_TYPES.LINK}
            text="Load previous comments"
            size={BUTTON_SIZES.SMALL}
            className={styles.fontWeightLight}
            isLoading={this.state.fetchingComments}
          />
        </div>
      );
    }
    return showMore;
  }

  render() {
    const {
      canCommentAnonymously,
      comments,
      commentsCount,
      currentUserId,
      error,
      eventObject,
      feedItemId,
      isAllocator,
      mentionables,
      postId,
      profileImageUrl
    } = this.props;

    if (error) throw error;

    let type = eventObject.__typename;
    let open = eventObject.isOpenAccess;
    let isOwner = false;

    if (type === 'Idea') {
      isOwner = currentUserId === eventObject.user.id;
    }

    if (type === 'AdminPost') {
      type = 'Post';
    }

    if (type === 'Comment') {
      type = eventObject.commentObject.__typename;
      open = eventObject.commentObject.isOpenAccess;
      isOwner = currentUserId === eventObject.commentObject.user.id;
    }

    if (type !== 'Post' && type !== 'EmployerProfile' && !open && !isOwner && commentsCount > 0) {
      return (
        <div className={styles.commentsWrap}>
          <em className={styles.noAccessText}>
            There {commentsCount === 1 ? 'is' : 'are'} <strong>{commentsCount} </strong>
            comment
            {commentsCount === 1 ? '' : 's'} on this {type.toLowerCase()}.{' '}
            <Link to={accessIdeasUrl()}>Obtain research access</Link> in order to view and comment
            on {type.toLowerCase()}
            s.
          </em>
        </div>
      );
    }

    if (
      type !== 'Post' &&
      type !== 'EmployerProfile' &&
      !open &&
      !isOwner &&
      (commentsCount === 0 || !commentsCount)
    ) {
      return (
        <div className={styles.commentsWrap}>
          <em className={styles.noAccessText}>
            <Link to={accessIdeasUrl()}>Obtain research access</Link> in order to comment on{' '}
            {type.toLowerCase()}
            s.
          </em>
        </div>
      );
    }

    return (
      <div className={styles.commentsWrap}>
        <TransitionGroup>
          {comments &&
            comments.edges.map(edge => {
              if (edge.node.parentId) return null;
              return (
                <CSSTransition
                  in
                  appear
                  classNames="fade"
                  timeout={1000}
                  showLikes={type !== 'EmployerProfile'}
                  key={`comment-${edge.node.id}-${feedItemId}`}
                >
                  <CommentContainer
                    allComments={comments.edges.map(e => e.node || null) || []}
                    canCommentAnonymously={canCommentAnonymously}
                    comment={edge.node}
                    feedItemId={feedItemId}
                    isAllocator={isAllocator}
                    mentionables={mentionables}
                    postId={postId}
                    profileImageUrl={profileImageUrl}
                    showLikes
                  />
                </CSSTransition>
              );
            })}
        </TransitionGroup>
        {this.renderLoadMoreSection()}
      </div>
    );
  }
}

export default Comments;
